import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop"]

  open() {
    this.panelTarget.classList.remove("-translate-x-full")
    this.panelTarget.classList.add("translate-x-0")
    this.backdropTarget.hidden = false
    document.body.classList.add("overflow-hidden", "lg:overflow-auto")
  }

  close() {
    this.panelTarget.classList.add("-translate-x-full")
    this.panelTarget.classList.remove("translate-x-0")
    this.backdropTarget.hidden = true
    document.body.classList.remove("overflow-hidden", "lg:overflow-auto")
  }
}
